var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var adbCommonOfferMapper = function (resp) {
    if (resp)
        return resp.map(function (item) {
            return __assign(__assign({}, item), { maX_TO_LIMIT: "", tO_CONSUMED: "", balancE_TO: "", aB_CONSUMED: "", adB_STATUS_ORDER: "", LADB_BalanceConsumHistory: item.ladB_BalanceConsumHistory });
        });
    return [];
};
